
var id = "publicCopy";
var markup = "<symbol viewBox=\"0 0 25 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"publicCopy\">\n<path clip-rule=\"evenodd\" d=\"M0.199951 12C0.199951 5.3724 5.57235 0 12.2 0C18.8276 0 24.2 5.3724 24.2 12C24.2 18.6276 18.8276 24 12.2 24C5.57235 24 0.199951 18.6276 0.199951 12ZM2.59995 12C2.59995 17.3016 6.89835 21.6 12.2 21.6C17.5016 21.6 21.8 17.3016 21.8 12C21.8 6.6984 17.5016 2.4 12.2 2.4C6.89835 2.4 2.59995 6.6984 2.59995 12Z\" />\n<g clip-path=\"url(#publicCopy_clip0_1262_6543)\">\n<path d=\"M7.69995 9.12891H14.45C14.6489 9.12891 14.8396 9.20792 14.9803 9.34858C15.1209 9.48923 15.2 9.67999 15.2 9.87891V16.6289C15.2 16.8278 15.1209 17.0186 14.9803 17.1592C14.8396 17.2999 14.6489 17.3789 14.45 17.3789H7.69995C7.50104 17.3789 7.31027 17.2999 7.16962 17.1592C7.02897 17.0186 6.94995 16.8278 6.94995 16.6289V9.87891C6.94995 9.67999 7.02897 9.48923 7.16962 9.34858C7.31027 9.20792 7.50104 9.12891 7.69995 9.12891Z\" />\n<path d=\"M16.7 6.87891C16.8989 6.87891 17.0896 6.95792 17.2303 7.09858C17.3709 7.23923 17.45 7.42999 17.45 7.62891V14.3789C17.45 14.5778 17.3709 14.7686 17.2303 14.9092C17.0896 15.0499 16.8989 15.1289 16.7 15.1289H15.95V9.12891C15.95 8.93969 15.8785 8.75744 15.7499 8.6187C15.6212 8.47996 15.4449 8.39497 15.2562 8.38078L15.2 8.37891H9.19995V7.62891C9.19995 7.42999 9.27897 7.23923 9.41962 7.09858C9.56027 6.95792 9.75104 6.87891 9.94995 6.87891H16.7Z\" />\n</g>\n<defs>\n<clipPath id=\"publicCopy_clip0_1262_6543\">\n<rect width=\"12\" height=\"12\" transform=\"translate(6.19995 6.12891)\" />\n</clipPath>\n</defs>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
